/**
 * Given an array of arrays, concatenates them with a separator in between each set of non-empty arrays.
 * @param arrays
 * @param separator
 * @returns {Array}
 */
export function concatAndSeparateArrays(separator, ...arrays) {
  if (!Array.isArray(arrays) || arrays.length === 0) {
    return [];
  }
  const concated = [];
  arrays.forEach((array) => {
    if (Array.isArray(array) && array.length) {
      if (concated.length) {
        concated.push(separator);
      }
      concated.splice(concated.length, 0, ...array);
    }
  });
  return concated;
}

export function isEqualArray(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false;
  }

  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((val) => arr2.includes(val));
}
/**
 * @param object
 * @param separator
 * @returns {Object}
 */
export const getCostBasisObjects = (account) => {
  return account?.isBrokerage
    ? {
        mutualFundCostBasisType: {
          value: account?.brokerageCostBasisMethods?.mutualFundCostBasisTypeId || 1,
          label: account?.brokerageCostBasisMethods?.mutualFundCostBasisType || 'Average Cost'
        },
        otherSecurityCostBasisType: {
          value: account?.brokerageCostBasisMethods?.otherSecurityCostBasisTypeId || 1,
          label: account?.brokerageCostBasisMethods?.otherSecurityCostBasisType || 'Average Cost'
        },
        dripCostBasisType: {
          value: account?.brokerageCostBasisMethods?.dripCostBasisTypeId || 1,
          label: account?.brokerageCostBasisMethods?.dripCostBasisType || 'Average Cost'
        }
      }
    : {
        costBasisType: {
          value: account?.costBasisTypeId || 1,
          label: account?.costBasisMethodMod || 'Average Cost'
        }
    };
};
